import { FuseUtils } from '@fuse/utils';
import { QueryDocumentSnapshot } from '@angular/fire/firestore';
import { Message } from '../../broadcasts/broadcast/broadcast.model';

export class SurveyAnswerOption {
    key: string;
    label?: string;
    submissionText?: string;
    engagementPoints?: number;
}
export class Survey
{
    id: string;
    name: string;
    productConfigId: number;
    enabled: boolean;
    startDate: Date;
    endDate?: Date;
    sendBroadcastAtStart?: boolean;
    introText?: string;
    answers: Array<SurveyAnswerOption>;
    submissionMessage?: Message;
    handle: string;
    createdByUserId: string;
    language: string; // 'de', 'en', 'all'
    createdAt: Date;
    updatedAt: Date;

    constructor(survey?)
    {
        console.log('Survey constructor', survey);
        survey = survey || {};
        this.id = survey.id; // || FuseUtils.generateGUID();
        this.name = survey.name || '';
        this.handle = survey.handle || FuseUtils.handleize(this.name);
        this.productConfigId = survey.productConfigId;
        this.startDate = survey.startDate;
        this.endDate = survey.endDate;
        this.enabled = survey.enabled;
        this.sendBroadcastAtStart = survey.sendBroadcastAtStart;
        this.introText = survey.introText;
        this.answers = survey.answers;
        this.submissionMessage = survey.submissionMessage;
        this.createdAt = survey.createdAt;
        this.updatedAt = survey.updatedAt;
        this.createdByUserId = survey.createdByUserId;
        console.log('Survey constructor, handle', this.handle, this);
    }

    /**
     * This is called when we load a Survey from Firebase.
     * @param id 
     * @param data 
     */
    static parseFirebaseData(id: string, data: any): any {
        console.log('parseFirebaseData begin', id, data);
        if (!data.id) {
            data.id = id;
        }
        if (data.startDate) {
          data.startDate = new Date(data.startDate.seconds * 1000);
        }
        if (data.endDate) {
          data.endDate = new Date(data.endDate.seconds * 1000);
        }
        if (data.createdAt) {
            data.createdAt = new Date(data.createdAt.seconds * 1000);
        }
        if (data.updatedAt) {
            data.updatedAt = new Date(data.updatedAt.seconds * 1000);
        }

        data.handle = FuseUtils.handleize(data.name);
        console.log('parseFirebaseData end', data);
        return data;
    }
}
